__turbopack_context__.v({
  "banner": "styles-module__rJZm_a__banner",
  "bannerItem": "styles-module__rJZm_a__bannerItem",
  "divider": "styles-module__rJZm_a__divider",
  "stampImage": "styles-module__rJZm_a__stampImage",
});
